<template>
    <div id="loginDialog" v-if="showLoginDialog">
        <div class="mask"></div>
        <div class="container">
            <p>单词量是一个不断变化的过程 登录后可保存测试记录</p>
            <div class="go_login" @click="login()" data-rlog="log_in">一键登录并记录结果</div>
            <div class="no_login" @click="noLogin" data-rlog="not_login">暂不登录</div>
        </div>
    </div>
</template>

<script>
    import { isYouDao, ydk } from './../libs/libs.js'
    export default {
        name: 'loginDialog',
        data () {
            return {
                a: 1
            }
        },
        props: {
            showLoginDialog: ''
        },
        methods: {
            login: function () {
                let that = this
                that.$emit('changeShowDialog', false)
                ydk.isLogin({
                    success: function (res) {
                        if (!res.isLogin) {
                            if (isYouDao == -1) {
                                window.location.href = 'https://c.youdao.com/dict/commons/login.html?back_url=' + encodeURIComponent(window.location.href)
                            } else {
                                ydk.login({
                                    defer: 3000,
                                    success: function (res) {
                                        that.$emit('changeShowDialog', false)
                                        that.$store.commit('ISLOGIN', true)
                                    }
                                })
                            }
                        }
                    }
                })
            },
            noLogin: function () {
                document.getElementById('app').style.height = '100%'
                this.$emit('changeShowDialog', false)
            }
        },
        
    }
</script>

<style>
    #loginDialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    #loginDialog .mask{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #000;
        opacity: 0.5;
    }
    #loginDialog .container {
        width: 6.7rem;
        height: 4.2rem;
        position: fixed;
        top: 3.32rem;
        left: 50%;
        margin-left: -3.35rem;
        background: rgba(255,255,255,1);
        border-radius: 6px;
        border: 1px solid rgba(225,225,225,1);
    }
    #loginDialog p {
        width: 4.16rem;
        height: 0.8rem;
        margin: 0.52rem auto 0.59rem;
        text-align: center;
        font-size: 0.32rem;
        font-family: PingFangSC-Semibold;
        color: rgba(72,78,94,1);
        line-height: 0.48rem;
    }
    .go_login {
        width: 5.50rem;
        height: 0.9rem;
        background: linear-gradient(135.4deg,rgba(255,175,36,1),rgba(255,138,38,1),rgba(255,135,38,1),rgba(255,135,38,1));
        box-shadow: 0px 4px 11px 0px rgba(254,187,97,0.36);
        border-radius: 1rem;
        text-align: center;
        font-size: 0.32rem;
        font-family: PingFangSC-Regular;
        color: rgba(255,255,255,1);
        line-height: 0.9rem;
        margin: 0 auto 0.4rem;
    }
    .no_login {
        width: 100%;
        text-align: center;
        font-size: 0.32rem;
        font-family: PingFangSC-Regular;
        color: rgba(144,148,158,1);
        line-height: 0.32rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/loginDialog.vue